import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointProps {
  children: React.ReactNode;
}
const FeaturePointGlpAdv3 = ({
  children
}: FeaturePointProps) => {
  return <div className="flex items-start" data-id="element-16946" data-mp="2dgtwy4m9f0tw">
      <div className="flex-shrink-0 mt-1" data-id="element-16947" data-mp="2dfr1djdzsa7n">
        <CheckIcon className="h-5 w-5 text-green-600" data-id="element-16948" data-mp="2dezi981l04y9" />
      </div>
      <div className="ml-2 text-base text-green-600" data-id="element-16949" data-mp="2iec4projja0b">{children}</div>
    </div>;
};
export default FeaturePointGlpAdv3;